import React from 'react';
import PropTypes from 'prop-types';
import Parser from 'html-react-parser';

class BlogText extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const {input} = this.props
        return Parser(input.primary.text.html)
    }
}

BlogText.propTypes = {
    input: PropTypes.object.isRequired,
};

export default BlogText;